import { luminance } from './utils'
import * as colors from './colors'
import * as logo from '../../assets/images/brand/logo.svg'
import * as inverted_logo from '../../assets/images/brand/inverted_logo.svg'

export const image = (): HTMLImageElement => {
  if (globalThis._IMAGES_.branding === undefined) {
    const image = new Image()
    image.crossOrigin = 'anonymous'
    image.onload = () => setAspectRatio(image)
    image.onerror = (error) => console.error(error)
    image.src = url()
    globalThis._IMAGES_.branding = image
  }
  return globalThis._IMAGES_.branding
}

const setAspectRatio = (image: HTMLImageElement): void => {
  globalThis._CONFIGURATION_.branding.aspectRatio = image.naturalWidth / image.naturalHeight
}

const url = (): string => {
  if (globalThis?._CONFIGURATION_?.branding?.url !== undefined) return globalThis._CONFIGURATION_.branding.url
  return luminance(colors.background()) > 0.4 ? logo.default : inverted_logo.default
}
